export default __webpack_public_path__ + "static/media/main-banner-cropped.964783d8.jpeg";